export default {"src":"/_next/static/media/black-arrow-left.2eac9f29.svg","height":12,"width":16,"blurWidth":0,"blurHeight":0};